import * as React from 'react';
import cn from 'clsx';
import './font/font.css';
import * as styles from './styles.css';

export interface ITextProps {
  children: React.ReactNode;
  color?: 'primary' | 'currentColor' | 'secondary' | 'error' | 'link';
  fontWeight?: 'normal' | 'bold';
  level?: number;
  tag?: 'span' | 'p' | 'div';
}

export const Text: React.FC<ITextProps> = props => {
  const { children, color = 'primary', fontWeight = 'normal', level = 1, tag = 'span' } = props;

  const Tag = tag;

  return (
    <Tag className={cn(styles['text'], styles[color], styles[fontWeight], styles[`level-${level}`])}>{children}</Tag>
  );
};

Text.displayName = 'Text';
